import {EmployeeStuckItem} from '../../../../../types';

export const formatStuckItems = (items: EmployeeStuckItem[]) => {
  const sortedItems = items
      .sort((item1, item2) => item1.seqNum - item2.seqNum);
  const middleIndex = Math.ceil(sortedItems.length / 2);

  const firstHalf = items.slice(0, middleIndex);
  const secondHalf = items.slice(middleIndex);

  return {firstHalf, secondHalf};
};
